"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failed = exports.InUse = exports.Stopped = exports.Prepared = exports.NotSupported = exports.NotRequested = exports.FlvHttpGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const flv_http_1 = require("../../drivers/video-element/flv-http");
const state_flow_2 = require("../state-flow");
const common_1 = require("./common");
//#endregion
//#region Group Declaration
exports.FlvHttpGroup = state_flow_2.PlayerStateFlow.registerGroup("flvHttp").bootstrap(() => {
    return (0, exports.NotRequested)({
        driverFormat: "flv-http",
        priority: -1,
        support: "",
        timeout: 0,
        features: {
            sourceQuality: false,
            forcedQuality: true,
            autoBitrate: false,
        },
    });
});
//#endregion
//#region Signals Handlers
function loadDriver(groups, signal) {
    const [priority, config] = (0, common_1.findDriver)(flv_http_1.FlvHttpDriver, signal.options.drivers);
    if (priority === -1) {
        return state_flow_1.Result.ignore();
    }
    const support = (0, common_1.checkDriverSupport)(flv_http_1.FlvHttpDriver, groups.host.element, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.flvHttp, priority, support, timeout: config.timeout });
    }
    return (0, exports.NotSupported)({ ...groups.flvHttp, priority, support });
}
function unloadDriver(groups, signal) {
    const [priority, _] = (0, common_1.findDriver)(flv_http_1.FlvHttpDriver, signal.options.drivers);
    if (priority !== -1) {
        return state_flow_1.Result.ignore();
    }
    return (0, exports.NotRequested)({ ...groups.flvHttp, priority });
}
function updateSupportHostStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(flv_http_1.FlvHttpDriver, signal.host, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.flvHttp, support });
    }
    return (0, exports.NotSupported)({ ...groups.flvHttp, support });
}
function updateSupportManifestStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(flv_http_1.FlvHttpDriver, groups.host.element, signal.manifest);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.flvHttp, support });
    }
    return (0, exports.NotSupported)({ ...groups.flvHttp, support });
}
// function nativeHlsLoad({ nativeHls, manifest }: Groups, signal: Signals["nativeHlsLoad"]): StateResult<Props> {
//   const format = manifest.json?.formats[nativeHls.driverFormat];
//   if (format == null) {
//     return NotSupported({ ...nativeHls });
//   }
//
//   return Loaded({ ...nativeHls });
// }
// function requestDriver({ nativeHls }: Groups, signal: Signals["requestDriver"]): StateResult<Props> {
//   return NotSupported(nativeHls);
// }
//#endregion
//#region States Declarations
exports.NotRequested = exports.FlvHttpGroup.registerState("NotRequested", {
    optionsApply: loadDriver,
});
exports.NotSupported = exports.FlvHttpGroup.registerState("NotSupported", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
});
exports.Prepared = exports.FlvHttpGroup.registerState("Prepared", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.FlvHttpGroup.name ? (0, exports.InUse)(g.flvHttp) : g.flvHttp;
    },
});
exports.Stopped = exports.FlvHttpGroup.registerState("Stopped", {
    optionsApply: unloadDriver,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.FlvHttpGroup.name ? (0, exports.InUse)(g.flvHttp) : g.flvHttp;
    },
});
exports.InUse = exports.FlvHttpGroup.registerState("InUse", {
    optionsApply: () => state_flow_1.Result.reject("driver is in use"),
    hostElementDetach: () => state_flow_1.Result.reject("host element is in use of FlvHttp"),
    // detachHostElement: (g) => Prepared(g.nativeHls),
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.FlvHttpGroup.name ? g.flvHttp : (0, exports.Stopped)(g.flvHttp);
    },
    manifestReplaceUrl: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return (0, exports.Prepared)(g.flvHttp);
    },
});
exports.Failed = exports.FlvHttpGroup.registerState("Failed", {
    optionsApply: unloadDriver,
});
//#endregion
//# sourceMappingURL=flv-http.js.map